export default {
  label: 'Chat met ons team',
  label_unread: 'Chat met ons team, {{count}} nieuw',
};
